import controller from './controller'
import template from './template.html'

export default {
  bindings: {
    categories: '<',
    itemGroup: '<'
  },
  template,
  controller
}
